const communicationLang = {
  menuTitle: 'Communication',
  relation: 'Relation',
  files: {
    pageTitle: 'Bibliothèque de fichiers',
    menu: 'Bibliothèque',
    createTitle: 'Ajout d\'un fichier à la bibliothèque',
    editTitle: 'Modification d\'un fichier de la bibliothèque',
    form: {
      name: 'Nom du fichier',
      nameExplain: '(Facultatif) il n\'est utilisé que dans le logiciel afin d\'identifier plus facilement les fichiers.',
      file: 'Fichier :',
      fileIsRequired: 'Vous devez sélectionner un fichier'
    },
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
    list: {
      name: 'Nom',
      filename: 'Nom du fichier',
      linkedElement: 'Élément lié'
    },
    newLabel: 'Nouveau fichier',
    fileAdded: 'Fichier ajouté',
    linkedType: 'Type d\'élément lié',
  },
  models: {
    pageTitle: 'Modèles d\'emails',
    menu: 'Modèles',
    createTitle: 'Création d\'un modèle',
    editTitle: 'Modification d\'un modèle',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
    form: {
      name: 'Nom du modèle',
      subject: 'Sujet',
      message: 'Message',
      files: 'Pièce(s) jointe(s) :',
      uploadBtn: 'Télécharger un fichier',
      libraryBtn: 'Bibliothèque de fichiers'
    },
    selectLabel: 'Modèles :',
    selectPlaceholder: 'Charger un modèle',
    list: {
      name: 'Nom du modèle'
    },
    newLabel: 'Nouveau modèle'
  },
  report: {
    report: 'Compte rendu',
    newTitle: 'Création d\'un compte-rendu',
    editTitle: 'Modification d\'un compte-rendu',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce compte-rendu ?',
    type: {
      1: 'Appel',
      2: 'Rendez-vous'
    },
    form: {
      type: 'Type de compte-rendu :',
      date: 'Date :',
      recipients: 'Correspondant(s) :',
      object: 'Sujet :',
      content: 'Description :',
      customer: 'Client',
      contact: 'Contact',
      user: 'Utilisateur'
    },
    list: {
      date: 'Date',
      type: 'Type',
      recipients: 'Participant(s)',
      customer: 'Tiers',
      subject: 'Sujet'
    },
    emptySubject: 'Aucun sujet',
    emptyContent: 'Aucune description'
  },
  reportType: {
    pageTitle: 'Gestion des types de comptes-rendus',
    menu: 'Comptes-rendus',
    label: 'Nom',
    new: 'Création d\'un type de compte-rendu',
    edit: 'Modification d\'un type de compte-rendu',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer le type de compte-rendu ?',
    cantDeleteMsg: 'Vous ne pouvez pas supprimer le type de compte-rendu car vous devez en avoir un au minimum'
  },
  letter: {
    newTitle: 'Création d\'une lettre',
    editTitle: 'Modification d\'une lettre',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette lettre ?',
    download: 'Télécharger la lettre',
    form: {
      date: 'Date :',
      address: 'Adresse du destinataire :',
      selectAddressPlaceholder: 'Selectionner une adresse',
      withAr: 'Recommandé avec accusé réception',
      subject: 'Object :',
      content: 'Message :',
      inGeneration: 'La lettre est en cours de génération',
      generated: 'Votre lettre a bien été générée.',
      generatingError: 'Une erreur est survenue lors de la génération de votre lettre',
      contactUpdated: 'Le contact a été mis à jour, voulez-vous réappliquer le modèle de lettre ?',
    },
    list: {
      date: 'Date',
      address: 'Adresse',
      tiers: 'Tiers',
      contact: 'Contact',
      subject: 'Object'
    },
    params: {
      explain: 'Vous avez la possibilité de personnaliser les lettres qui seront générées depuis le logiciel en utilisant un document Word.',
      model: 'Modèle de lettre',
      deleteMsg: 'Êtes-vous sûr de vouloir supprimer le modèle de lettre ?',
      fileType: 'Fichier word (.docx) ou Open Office (.odt) uniquement.',
      explain2: 'Si vous ne téléchargez pas de modèle personnalisé, c\'est le modèle par défaut qui est utilisé.',
      downloadDefault: 'Télécharger le modèle par défaut',
      variableExplain1: 'Liste des variables dynamiques qui peuvent être utilisées dans le document Word.',
      variableExplain2: 'Celles-ci seront automatiquement remplacées lors de la génération de la lettre.',
      variable: 'Variable',
      description: 'Désignation',
      userFirstname: 'Prénom de l\'utilisateur qui créer la lettre',
      userLastname: 'Nom de l\'utilisateur qui créer la lettre',
      userFullname: 'Prénom + Nom de l\'utilisateur qui créer la lettre',
      companyName: 'Nom de votre entreprise',
      companyAddress: 'Adresse de votre entreprise',
      companyTown: 'Ville de votre entreprise',
      address: 'Adresse de destination',
      contactCivility: 'Civilité du contact (Ex: Monsieur)',
      contactCivilityShort: 'Civilité abrégée du contact (Ex: M)',
      contactFirstname: 'Prénom du contact',
      contactLastname: 'Nom du contact',
      contactFullname: 'Prénom + Nom du contact',
      date: 'Date d\'envoi',
      subject: 'Sujet de la lettre',
      sendAr: 'Remplacer les XXX par votre phrase. Dans le cas d\'un envoi qui n\'est pas en accusé réception, la phrase sera supprimée.',
      content: 'Contenu de la lettre'
    },
    emptySubject: 'Aucun sujet',
    emptyContent: 'Aucun message'
  },
  params: {
    pageTitle: 'Paramètres par défaut',
    menu: 'Paramètres',
    explain: 'Vous pouvez choisir des modèles à utiliser par défaut. Ils seront alors préchargés lorsque vous envoyez un email depuis une fiche (devis ou clients par ex.).',
    fromProspect: 'Depuis une fiche prospect :',
    fromCustomer: 'Depuis une fiche client :',
    fromProvider: 'Depuis une fiche fournisseur :',
    fromSubcontractor: 'Depuis une fiche sous-traitant :',
    fromQuotation: 'Depuis une fiche devis :',
    fromCommand: 'Depuis une fiche bon de commande :',
    fromProforma: 'Depuis une fiche facture proforma :',
    fromDelivery: 'Depuis une fiche bon de livraison :',
    fromInvoice: 'Depuis une fiche facture :',
    fromCredit: 'Depuis une fiche avoir :',
    fromProviderCommand: 'Depuis une fiche commande fournisseur :'
  },
  letters: {
    pageTitle: 'Paramètres des lettres',
    menu: 'Lettres'
  },
  senders: {
    label: 'Expéditeurs',
    pageTitle: 'Gestion des expéditeurs des emails',
    createTitle: 'Création d\'un expéditeur',
    editTitle: 'Modification d\'un expéditeur',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cet expéditeur ?',
    newLabel: 'Nouvel expéditeur',
    form: {
      confirmationSend: 'L\'email de validation a été envoyé.',
      waitValidation: 'Expéditeur en attente de validation. Vous devez cliquer sur le lien qui a été envoyé par email.',
      resendValidation: 'Renvoyer l\'email de validation',
      name: 'Nom de l\'expéditeur :',
      mail: 'Adresse email :',
      validationExplain1: 'Un email avec un lien de validation sera envoyé afin de valider que vous êtes bien le propriétaire de cette adresse email.',
      validationExplain2: 'Vous ne pourrez utiliser cet email qu\'après la validation.',
      useDefault: 'Utiliser par défaut :',
      configType: 'Type de configuration :',
      defaultServer: 'Serveur d\'envoi par défaut',
      defaultExplain: 'L\'adresse email d\'expéditeur sera celle du logiciel mais l\'adresse email que vous avez indiquée sera utilisée lorsque votre destinataire vous répondra.',
      smtp: 'Serveur smtp personnalisé',
      serverAddress: 'Adresse du serveur :',
      serverPort: 'Port :',
      serverSecurity: 'Sécurité :',
      none: 'Non',
      serverAuth: 'Authentification :',
      login: 'Login :',
      password: 'Mot de passe :',
      tracking: 'Tracking des emails :',
      trackOpen: 'Traquer les ouvertures d\'email',
      trackClick: 'Traquer les clics sur les liens présents dans les emails',
      share: 'Partager cet expéditeur avec les autres utilisateurs :',
      shareExplain: 'Les autres utilisateurs pourront alors envoyer des emails via cet expéditeur.',
      sign: 'Signature :'
    },
    list: {
      explain: 'Vous avez la possibilité de configurer une ou plusieures adresses emails afin d\'envoyer vos emails depuis le logiciel.',
      name: 'Nom de l\'expéditeur',
      mail: 'Email',
      trackOpen: 'Suivi ouverture',
      trackLink: 'Suivi lien',
      share: 'Partagée',
      status: 'Statut',
      statusActive: 'Actif',
      statusWait: 'En attente de validation',
      useDefault: 'Par défaut'
    }
  },
  mail: {
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cet email ?',
    mail: 'Email',
    form: {
      tiers: 'Tiers',
      contact: 'Contact',
      user: 'Utilisateur',
      saveClose: 'Enregistrer et Fermer',
      from: 'De',
      to: 'À',
      cc: 'Cc',
      addCc: 'Ajouter des destinataires en copie',
      cci: 'Cci',
      addCci: 'Ajouter des destinataires en copie cachée',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer',
      addFiles: 'Joindre des fichiers',
      filesLibrary: 'Bibliothèque de fichiers',
      filesCustomer: 'Fichiers client',
      loadModel: 'Charger un modèle',
      contactUpdated: 'Le destinataire a été mis à jour, voulez-vous réappliquer le modèle d\'email ?',
      enlarge: 'Agrandir',
      reduce: 'Réduire',
      fullscreen: 'Plein écran',
      fullscreenOut: 'Sortir du plein écran',
      newMessage: 'Nouveau message',
      needValidSender: 'Vous devez valider votre adresse d\'expédition pour pouvoir envoyer des emails.',
      needAddSender: 'Vous devez ajouter une adresse d\'expédition pour envoyer des emails',
      validSender: 'Pour valider votre adresse email, vous devez cliquer dans le lien que vous avez reçu par email.',
      senderConfig: 'Gérer mes adresses d\'expédition',
      resend: 'Renvoyer l\'email',
      noModel: 'Aucun modèle',
      noSearchModel: 'Aucun résultat',
      searchModel: 'Rechercher...',
      limitExplain1: 'Vous avez atteint la limite d\'envoi. Vous devez patienter avant de pouvoir à nouveau envoyer des emails.',
      limitExplain2: 'Vous pouvez débloquer ce quota',
      limitExplain3: 'en créant un nouvel expéditeur',
      limitExplain4: 'En configuration votre serveur SMTP',
      limitExplain5: 'En connectant votre compte Gmail',
      limitExplain6: 'En connectant votre compte Outlook',
    },
    confirmSenderTitle: 'Validation d\'une adresse email',
    confirmSenderMessage: 'L\'adresse email "{email}" a bien été validée, vous pouvez maintenant l\'utiliser pour envoyer des emails.',
    confirm404Error: 'Aucune validation d\'email ne correspond. Soit l\'email a déjà été validé, soit le lien est incorrect.',
    sendError: 'Une erreur est survenue lors de l\'envoi de l\'email',
    read: 'Lu :',
    emptySubject: 'Aucun sujet',
    emptyContent: 'Aucun message'
  },
  attachmentDeleteMsg: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe ?',
  today: {
    days: {
      1: 'lundi',
      2: 'mardi',
      3: 'mercredi',
      4: 'jeudi',
      5: 'vendredi',
      6: 'samedi',
      7: 'dimanche'
    },
    months: {
      1: 'janvier',
      2: 'février',
      3: 'mars',
      4: 'avril',
      5: 'mai',
      6: 'juin',
      7: 'juillet',
      8: 'août',
      9: 'septembre',
      10: 'octobre',
      11: 'novembre',
      12: 'décembre'
    }
  },
  variables: {
    company: {
      title: 'Informations de votre entreprise',
      name: 'Nom de l\'entreprise',
      type: 'Type d\'entreprise',
      siret: 'N° SIRET',
      rcs: 'N° RCS',
      tva: 'N° TVA intracommunautaire',
      naf: 'Code NAF',
      capital: 'Capital'
    },
    customer: {
      title: 'Informations sur le client',
      name: 'Nom du client',
      code: 'Code du client'
    },
    contact: {
      title: 'Informations sur le contact',
      fullname: 'Nom complet',
      civility: 'Civilité abrégée (Ex: M.)',
      civilityFull: 'Civilité complète (Ex: Monsieur)',
      firstname: 'Prénom',
      lastname: 'Nom de famille',
      function: 'Fonction'
    },
    document: {
      title: 'Informations sur le document',
      reference: 'Numéro du document',
      date: 'Date',
      expDate: 'Date d\'expiration',
      customerCommand: 'N° du bon de commande client',
      invoiceAddress: 'Adresse de facturation',
      deliveryAddress: 'Adresse de livraison',
      documentTitle: 'Titre',
      depositAmount: 'Montant de l\'acompte',
      escompte: 'Escompte',
      escompteHt: 'Montant escompte HT',
      escompteTva: 'Montant escompte TVA',
      escompteTtc: 'Montant escompte TTC',
      penalty: 'Taux de pénalité',
      paymentTerm: 'Conditions de paiement',
      totalHt: 'Total HT',
      totalTva: 'Total TVA',
      totalTtc: 'Total TTC',
      toPaid: 'Montant à payer',
      alreadyPaid: 'Montant déjà payé',
      stayToPaid: 'Montant restant à payé',
      paymentLink: 'Lien de paiement',
      tracking: 'N° de suivi de la livraison'
    },
    date: {
      title: 'Date du jour',
      today: 'Date au format DD-MM-AAAA',
      todayNumber: 'Jour (lundi, mardi...)',
      dayNumber: 'Numéro du jour (1, 2, 3...)',
      monthNumber: 'Numéro du mois (1, 2, 3...)',
      month: 'Mois (janvier, février...)',
      year: 'Année'
    },
    signatureTitle: 'Signature électronique',
    signatureLink: 'Lien pour signer le document',
    construction: {
      title: 'Information sur le chantier',
      reference: 'Numéro du chantier',
      constructionTitle: 'Titre du chantier',
      contact: 'Contact du chantier',
      address: 'Adresse du chantier',
      begin: 'Début de la planification',
      end: 'Fin de la planification'
    },
    senderTitle: 'Informations sur l\'expéditeur',
    road: 'Adresse - rue',
    road2: 'Adresse - rue 2',
    road3: 'Adresse - rue 3',
    postal: 'Code postal',
    town: 'Ville',
    country: 'Pays',
    phone: 'Téléphone fixe',
    mobile: 'Téléphone portable',
    fax: 'Fax',
    email: 'Email',
    website: 'Site internet'
  },
  mailbox: {
    pageTitle: 'Boîte mail'
  }
}

const agregateDatas = {
  loadMore: 'Charger plus d\'éléments',
  noDatas: 'Aucune donnée à afficher',
  newElement: 'Nouvel élément',
  file: 'Fichier',
  files: 'Fichiers',
  filesList: 'Liste des fichiers :',
  noFile: 'Aucun fichier',
  comment: 'Note',
  comments: 'Notes',
  task: 'Tâche',
  tasks: 'Tâches',
  report: 'Compte-rendu',
  reports: 'Compte-rendus',
  letter: 'Lettre',
  letters: 'Lettres',
  mails: 'Mails',
  history: 'Historique',
  appointment: 'Rendez-vous',
  appointments: 'Rendez-vous',
  commentBy: 'Commentaire par {name}',
  fileAdded: 'Ajout d\'un fichier',
  mailSendBy: '{name} a envoyé un email :',
  paymentLinkSendBy: '{name} a envoyé un lien de paiement pour un montant de {amount} à',
  paymentLink: 'Envoi d\'un lien de paiement pour un montant de {amount} à',
  paymentLinkExpired: 'À expiré le {datetime}',
  paymentLinkCanceled: 'Annulé le {datetime}',
  paymentLinkPaid: 'Payé le {datetime}',
  see: 'Voir',
  letterSend: 'Envoi d\'une lettre par {name}',
  render: 'Compte rendu : {type} par {name}'
}

export default {
  communication: communicationLang,
  agregateDatas
}
